var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommissionHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.565 4.895c0-1.157.742-2.095 1.92-2.095 1.179 0 1.92.938 1.92 2.095l.214 8.381c0-.381.534-5.93.534-6.286 0-1.047.635-2.095 1.813-2.095s1.92.938 1.92 2.095v7.614c.089-.05.32-4.029.32-4.47 0-1.048.28-2.096 1.28-2.096 1.001 0 1.601.938 1.601 2.095v6.286c0 4.629-3.821 8.381-8.535 8.381h-.719c-3.232 0-6.188-1.794-7.634-4.633l-3.031-5.954a1.543 1.543 0 01.768-2.12c.45-.196.957-.307 1.433-.158 1.182.37 1.007.9 1.715 1.561V6.99c0-1.157.742-2.095 1.92-2.095 1.067 0 1.717 1.378 1.814 2.095.133.983.533 5.903.534 6.284l.213-8.379z",
    fill: "#FDAD15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.697 17.057c-.48 2.36-1.627 3.541-2.904 4.28",
    stroke: "#FFF8BB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 22.672,
    r: 1,
    fill: "#FFF8BB"
  })));
}

export default SvgCommissionHand;